import * as React from "react"

import { cn } from "@/lib/utils"

const PICKER_TYPES = ["date", "time", "datetime-local", "month", "week"]

const Input = React.forwardRef(({ className, type, onClick, onFocus, ...props }, ref) => {
  // Native date/time inputs only open their calendar when the tiny icon is clicked.
  // Open the picker on any click/focus of the field so the calendar always works.
  const openPicker = (e) => {
    if (PICKER_TYPES.includes(type) && typeof e.target?.showPicker === "function") {
      try {
        e.target.showPicker()
      } catch {
        // showPicker can throw (unsupported browser / cross-origin iframe) — native icon still works
      }
    }
  }
  const handleClick = (e) => {
    onClick?.(e)
    openPicker(e)
  }
  const handleFocus = (e) => {
    onFocus?.(e)
    openPicker(e)
  }
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        PICKER_TYPES.includes(type) && "cursor-pointer",
        className
      )}
      ref={ref}
      onClick={handleClick}
      onFocus={handleFocus}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
